import { Node, nodeInputRule, mergeAttributes } from '@tiptap/core';

export interface StPlaceholderOptions {
  inline?: boolean;
  HTMLAttributes?: Record<string, any>;
  getRandId?: Function;
  stImageDefaultWidth?: number;
  stImageDefaultHeight?: number;
  corsProxyBaseUrl?: string;
}

export const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

export default Node.create<StPlaceholderOptions>({
  name: 'st-image-placeholder',
  draggable: false,

  addAttributes() {
    return {
      imgsrc: {
        default: '',
      },
      uploadId: {
        default: '',
      },
      width: {
        default: undefined,
      },
      height: {
        default: undefined,
      },
    };
  },
  addOptions() {
    return {
      inline: false,
      HTMLAttributes: {},
    };
  },

  inline() {
    return this.options.inline;
  },

  group() {
    return `stImageGroup ${this.options.inline ? 'inline' : 'block'}`;
  },

  parseHTML() {
    return [
      { tag: 'st-image-placeholder' },
      {
        tag: 'img[src]',
        getAttrs: (el: string | HTMLElement) => {
          // @ts-ignore
          let { width, height } = el;
          if ((width || height) === 0) {
            width = this.options.stImageDefaultWidth;
            height = this.options.stImageDefaultHeight;
          }
          const url = el instanceof HTMLElement ? el.getAttribute('src') : '';
          const src = url?.startsWith?.('data:')
            ? url
            : `${this.options.corsProxyBaseUrl}${encodeURIComponent(url ?? '')}`;
          return {
            imgsrc: src,
            uploadId: this.options.getRandId?.(),
            width,
            height,
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(this.options.HTMLAttributes ?? {}, HTMLAttributes)];
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => {
          const [, , uploadId] = match;

          return { uploadId };
        },
      }),
    ];
  },
});
